import { Injectable } from '@angular/core';

@Injectable()
export class SideBarService {

    sideBarVisible: boolean;

    constructor() {
        this.sideBarVisible = false;
    }

    hide() {
        this.sideBarVisible = false;
    }

    show() {
        this.sideBarVisible = true;
    }

    toggle() {
        this.sideBarVisible = !this.sideBarVisible;
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.service.ts